import { render } from "./HorseEditCoveringView.vue?vue&type=template&id=64466a98"
import script from "./HorseEditCoveringView.vue?vue&type=script&lang=js"
export * from "./HorseEditCoveringView.vue?vue&type=script&lang=js"

import "./HorseEditCoveringView.vue?vue&type=style&index=0&id=64466a98&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__